"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyGtx = emptyGtx;
exports.addTransactionToGtx = addTransactionToGtx;
exports.addSignerToGtx = addSignerToGtx;
exports.getDigest = getDigest;
exports.getDigestToSign = getDigestToSign;
exports.getDigestToSignFromRawGtxBody = getDigestToSignFromRawGtxBody;
exports.gtxToRawGtxBody = gtxToRawGtxBody;
exports.gtxToRawGtx = gtxToRawGtx;
exports.sign = sign;
exports.addSignature = addSignature;
exports.serialize = serialize;
exports.deserialize = deserialize;
exports.checkGTXSignatures = checkGTXSignatures;
exports.checkExistingGTXSignatures = checkExistingGTXSignatures;
exports.newSignatureProvider = newSignatureProvider;
exports.rawGtvToGtx = rawGtvToGtx;
const buffer_1 = require("buffer");
const gtv = __importStar(require("../gtv"));
const encryption_1 = require("../encryption/encryption");
const errors_1 = require("./errors");
const index_1 = require("./index");
const formatter_1 = require("../formatter");
const bufferUtils_1 = require("../utils/bufferUtils");
function emptyGtx(blockchainRid) {
    return { blockchainRid, operations: [], signers: [] };
}
/**
 * Adds a function call to a GTX. Creates a new GTX if none specified.
 * This function will throw Error if gtx is already signed
 * @param opName the name of the function to call
 * @param args the array of arguments of the function call. If no args, this must be an empty array
 * @param gtx the function call will be added to this gtx
 * @returns the gtx
 * @throws if gtx is null or if gtx is already signed
 */
function addTransactionToGtx(opName, args, gtx) {
    if (gtx == null) {
        throw new errors_1.MissingGtxException();
    }
    if (gtx.signatures) {
        throw new errors_1.AlreadySignedTransactionException("function");
    }
    gtx.operations.push({ opName: opName, args: args });
    return gtx;
}
function addSignerToGtx(signer, gtx) {
    if (gtx.signatures) {
        throw new errors_1.AlreadySignedTransactionException("signer");
    }
    gtx.signers.push(signer);
}
/**
 * Serializes the gtx to get tx hash
 * @param gtx the gtx to serialize
 */
function getDigest(gtx, merkleHashVersion) {
    return gtv.gtvHash(gtxToRawGtxBody(gtx), merkleHashVersion);
}
/**
 * Serializes the gtx for signing
 * @param gtx the gtx to serialize
 */
function getDigestToSign(gtx, merkleHashVersion) {
    return gtv.gtvHash(gtxToRawGtxBody(gtx), merkleHashVersion);
}
function getDigestToSignFromRawGtxBody(gtxBody, merkleHashVersion) {
    return gtv.gtvHash(gtxBody, merkleHashVersion);
}
function gtxToRawGtxBody(gtx) {
    return [
        gtx.blockchainRid,
        gtx.operations.map((op) => [op.opName, op.args]),
        gtx.signers,
    ];
}
function gtxToRawGtx(gtx) {
    var _a;
    return [
        [
            gtx.blockchainRid,
            gtx.operations.map((op) => [op.opName, op.args]),
            gtx.signers,
        ],
        (_a = gtx.signatures) !== null && _a !== void 0 ? _a : [],
    ];
}
function sign(gtx, privOrSigProv, merkleHashVersion, pubKey) {
    return __awaiter(this, void 0, void 0, function* () {
        if ((0, bufferUtils_1.isBuffer)(privOrSigProv)) {
            const digestToSign = getDigestToSign(gtx, merkleHashVersion);
            const signature = (0, encryption_1.signDigest)(digestToSign, privOrSigProv);
            return addSignature(pubKey || (0, encryption_1.makeKeyPair)(privOrSigProv).pubKey, signature, gtx);
        }
        else {
            // Removes signatures and extract the rawgtxBody
            const rawGtxBody = gtxToRawGtxBody(gtx);
            const signature = yield privOrSigProv.sign(rawGtxBody, merkleHashVersion);
            return addSignature(privOrSigProv.pubKey, signature, gtx);
        }
    });
}
/**
 * Adds a signature to the gtx
 */
function addSignature(pubKeyBuffer, signatureBuffer, gtx) {
    if (!gtx.signatures) {
        gtx.signatures = Array(gtx.signers.length);
    }
    const signerIndex = gtx.signers.findIndex((signer) => pubKeyBuffer.equals(signer));
    if (signerIndex === -1) {
        throw new errors_1.MissingSignerException();
    }
    gtx.signatures[signerIndex] = signatureBuffer;
    return gtx;
}
function serialize(gtx) {
    if (!gtx.signatures) {
        // TODO
        // The gtx is not signed, but we must include
        // the signatures attribute, so let's add that.
        gtx.signatures = [];
    }
    return (0, index_1.encode)([gtxToRawGtxBody(gtx), gtx.signatures]);
}
function deserialize(gtxBytes) {
    const deserializedTx = (0, index_1.decode)(gtxBytes);
    const body = deserializedTx[0];
    const gtvTxBody = {
        blockchainRid: body[0],
        operations: body[1].map((operation) => ({
            opName: operation[0],
            args: operation[1],
        })),
        signers: body[2],
    };
    const signatures = deserializedTx[1];
    return {
        blockchainRid: gtvTxBody.blockchainRid,
        operations: gtvTxBody.operations,
        signers: gtvTxBody.signers,
        signatures,
    };
}
function checkGTXSignatures(txHash, gtx) {
    var _a;
    if (!Array.isArray(gtx.signatures) || gtx.signatures.length === 0) {
        return false;
    }
    for (const i in gtx.signers) {
        const signValid = (0, encryption_1.checkDigestSignature)(txHash, gtx.signers[i], (_a = gtx.signatures) === null || _a === void 0 ? void 0 : _a[i]);
        if (!signValid)
            return signValid;
    }
    return true;
}
function checkExistingGTXSignatures(txHash, gtx) {
    var _a;
    for (const i in gtx.signers) {
        if ((_a = gtx.signatures) === null || _a === void 0 ? void 0 : _a[i]) {
            const signValid = (0, encryption_1.checkDigestSignature)(txHash, gtx.signers[i], gtx.signatures[i]);
            if (!signValid)
                return signValid;
        }
    }
    return true;
}
function newSignatureProvider(keyPair) {
    let pub, priv;
    if (keyPair) {
        priv = (0, formatter_1.ensureBuffer)(keyPair.privKey);
        pub = keyPair.pubKey ? (0, formatter_1.ensureBuffer)(keyPair.pubKey) : (0, encryption_1.createPublicKey)(priv);
    }
    else {
        ({ privKey: priv, pubKey: pub } = (0, encryption_1.makeKeyPair)());
    }
    return {
        pubKey: pub,
        sign: (gtx, merkleHashVersion) => __awaiter(this, void 0, void 0, function* () {
            const signature = getDigestToSignFromRawGtxBody(gtx, merkleHashVersion);
            return (0, encryption_1.signDigest)(signature, priv);
        }),
    };
}
function rawGtvToGtx(gtv) {
    if (Array.isArray(gtv) && gtv.length !== 2) {
        throw new Error("Gtv must be an array of size 2");
    }
    const gtvArray = gtv;
    if (!Array.isArray(gtvArray[0])) {
        throw new Error("First element must be an array");
    }
    if (!Array.isArray(gtvArray[1])) {
        throw new Error("Second element must be an array");
    }
    gtvArray[1].forEach(element => {
        if (!buffer_1.Buffer.isBuffer(element)) {
            throw new Error("Element must be a buffer");
        }
    });
    const gtxBody = rawGtvToGtxBody(gtvArray[0]);
    return Object.assign(Object.assign({}, gtxBody), { signatures: gtvArray[1] });
}
function rawGtvToGtxBody(gtv) {
    if (Array.isArray(gtv) && gtv.length !== 3) {
        throw new Error("Gtv must be an array of size 3");
    }
    const array = gtv;
    if (!buffer_1.Buffer.isBuffer(array[0])) {
        throw new Error("First element must be a byte array");
    }
    if (!Array.isArray(array[1])) {
        throw new Error("Second element must be an array");
    }
    if (!Array.isArray(array[2])) {
        throw new Error("Third element must be an array");
    }
    array[2].forEach(element => {
        if (!buffer_1.Buffer.isBuffer(element)) {
            throw new Error("Element must be a buffer");
        }
    });
    return {
        blockchainRid: array[0],
        operations: array[1].map(element => rawGtvToRellOp(element)),
        signers: array[2],
    };
}
function rawGtvToRellOp(gtv) {
    if (Array.isArray(gtv) && gtv.length !== 2) {
        throw new Error("Gtv must be an array of size 2");
    }
    const array = gtv;
    if (typeof array[0] !== "string") {
        throw new Error("First element must be a string");
    }
    if (!Array.isArray(array[1])) {
        throw new Error("Second element must be an array");
    }
    return { opName: array[0], args: array[1] };
}
//# sourceMappingURL=gtx.js.map